(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["ReviewWidget"] = factory(require("react"));
	else
		root["ReviewWidget"] = factory(root["React"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__12__) => {
return 